import React, { PureComponent, ReactElement } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SideBarProps } from '../types';
import { formatDate, oneYear, toDateString, today } from '../utils';

interface DateSidebarState {
  fromDate: Date;
  toDate: Date;
  fromIsOpen: boolean;
  toIsOpen: boolean;
}

export default class DateSidebar extends PureComponent<SideBarProps, DateSidebarState> {
  constructor(props: SideBarProps) {
    super(props);

    this.state = {
      fromDate: today(),
      toDate: oneYear(),
      fromIsOpen: false,
      toIsOpen: false,
    };
  }
  handleChangeFrom = (date: Date): void => {
    this.setState({ fromDate: date, fromIsOpen: false });
    this.props.fetchActivities({ from: formatDate(date) });
  };
  handleChangeTo = (date: Date): void => {
    this.setState({ toDate: date, toIsOpen: false });
    this.props.fetchActivities({ to: formatDate(date) });
  };
  render(): ReactElement {
    let fromPicker;
    let toPicker;
    if (this.state.fromIsOpen) {
      fromPicker = (
        <div>
          <DatePicker
            inline
            selectsStart
            scrollableYearDropdown
            showYearDropdown
            selected={this.state.fromDate}
            onChange={this.handleChangeFrom}
            locale="sv-SE"
            dropdownMode="select"
          />
        </div>
      );
    } else {
      fromPicker = (
        <div className="full-width-button datepicker-item">
          <div className="date-label">Från:</div>
          <button
            className="btn btn-datepicker"
            onClick={(): void => {
              this.setState({ fromIsOpen: true });
            }}
          >
            {toDateString(this.state.fromDate)}
          </button>
        </div>
      );
    }
    if (this.state.toIsOpen) {
      toPicker = (
        <div>
          <DatePicker
            inline
            scrollableYearDropdown
            showYearDropdown
            selected={this.state.toDate}
            onChange={this.handleChangeTo}
            locale="sv-SE"
            dropdownMode="select"
          />
        </div>
      );
    } else {
      toPicker = (
        <div className="full-width-button datepicker-item">
          <div className="date-label">Till:</div>
          <button
            className="btn btn-datepicker"
            onClick={(): void => {
              this.setState({ toIsOpen: true });
            }}
          >
            {toDateString(this.state.toDate)}
          </button>
        </div>
      );
    }
    return (
      <div className="contextual-region block block-sidebar-first hb-container closed">
        <div className="block-title">
          <h3>
            <span className="disable-select">Datum</span>
            <div className="hb-toggle-trigger">
              <div className="hb-toggle">
                <div className="hb-toggle-icon" />
              </div>
            </div>
          </h3>
        </div>

        <div className="block-content-outer hb-item-content closed">
          <div className="block-content hb-item-content-inner">
            {fromPicker}
            {toPicker}
          </div>
        </div>
      </div>
    );
  }
}
